import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'section', method: 'GET', body: null, token: token })
}
